import * as React from "react";

import Icon from "./Icon";

interface Props {
  filled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
}

const defaultProps: Partial<Props> = {
  filled: false,
};

const StarIcon: React.SFC<Props> = ({ className, filled, onClick }) => {
  return <Icon className={className} name={filled ? "wt-icon-star" : "wt-icon-star-o-1"} onClick={onClick} />;
};

StarIcon.defaultProps = defaultProps;

export default StarIcon;



// WEBPACK FOOTER //
// ./frontend/src/common/components/StarIcon.tsx